(ns lupapalvelu.shared-user
  (:require [sade.strings :as ss]))

(defn- make-name [user & ks]
  (->> user
       ((apply juxt ks))
       (ss/trim-join " ")))

(defn full-name
  "Firstname Lastname from the corresponding `user` fields (`:firstName`,
  `:lastName`). Parts are trimmed and blanks omitted. In other words, can return an empty
  string."
  [user]
  (make-name user :firstName :lastName))

(defn last-first
  "Like `full-name`, but the result string format is Lastname Firstname."
  [user]
  (make-name user :lastName :firstName))
